import { render, staticRenderFns } from "./PreviewFileComponent.vue?vue&type=template&id=f5da79e0&scoped=true"
import script from "./PreviewFileComponent.vue?vue&type=script&lang=js"
export * from "./PreviewFileComponent.vue?vue&type=script&lang=js"
import style0 from "./PreviewFileComponent.vue?vue&type=style&index=0&id=f5da79e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5da79e0",
  null
  
)

export default component.exports